import {
  POSTStudentDetails,
  UpdateStudentRequest,
} from '@/apis/family_application/student-details.requests'
import { addAttestations, upsertStudent } from './familyApplicationSlice'
import {
  FamilyApplicationEndpoints,
  Student,
} from '@/apis/family_application/requests'
import { createAppAsyncThunk } from './familyApplication.constants'

// Thunks
export const updateStudent = createAppAsyncThunk<Student, UpdateStudentRequest>(
  FamilyApplicationEndpoints.update_student,
  async (payload, thunkAPI) => {
    const response = await POSTStudentDetails(payload)
    if (response.error) {
      return thunkAPI.rejectWithValue(response.error)
    }
    let data = response.data
    if (response.data.attestations != undefined) {
      const { attestations, ...filteredData } = response.data
      data = filteredData
      thunkAPI.dispatch(addAttestations(attestations))
    }
    thunkAPI.dispatch(upsertStudent(data))

    return data
  }
)
